
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import Slider from "./components/OurTransportOperationalTransportBlock/Slider";

export default BaseCmsBlock.extend({
  name: "OurTransportOperationalTransportBlock",

  computed: {
    title: function () {
      return this.externalData?.OurTransportOperationalTransportBlock?.title || ""
    },
    subtitle: function () {
      return this.externalData?.OurTransportOperationalTransportBlock?.subtitle || ""
    },
    textButton: function () {
      return this.externalData?.OurTransportOperationalTransportBlock?.text_button || "Заказать"
    },
    products: function () {
      return this.externalData?.OurTransportOperationalTransportBlock?.products || []
    },

    isVisible: function () {
      const device = this.$store.state.device?.device;

      const isMobile = Boolean(this.cfgs?.visible_mobile && device?.isMobile);
      const isTablet = Boolean(this.cfgs?.visible_laptop && device?.isTablet);
      const isDesktop = Boolean(this.cfgs?.visible_pc && device?.isDesktop);

      return Boolean(isMobile || isTablet || isDesktop)
    }
  },

  components: {
    Slider
  },

  methods: {
    requestForm: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Заказать звонок',
          hideTabs: true,
        }
      });
    }
  }
})
